/**
 * PDP sticky add-to-cart bar — shows when main ATC scrolls out of view.
 */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents !== 'number') return '';
    var fmt = format || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var centsStr = parts[1] ? '.' + parts[1] : '';

    if (fmt.indexOf('amount_no_decimals') !== -1) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, dollars);
    }
    if (fmt.indexOf('amount_with_comma_separator') !== -1) {
      return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dollars + ',' + (parts[1] || '00'));
    }
    return fmt.replace(/\{\{\s*amount\s*\}\}/, dollars + centsStr);
  }

  function syncStickyTopOffset() {
    var stickyHeader = document.querySelector('sticky-header');
    var headerSection = document.querySelector('.section-header');
    var headerHeight = 0;

    if (stickyHeader) {
      headerHeight = stickyHeader.offsetHeight;
    } else if (headerSection) {
      headerHeight = headerSection.offsetHeight;
    }

    var cssHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    );
    if (cssHeight > headerHeight) {
      headerHeight = cssHeight;
    }

    if (headerHeight > 0) {
      document.documentElement.style.setProperty('--pdp-sticky-atc-top', headerHeight + 'px');
    }
  }

  var STICKY_TOP_LAYOUT_MAX_WIDTH = 999;

  function isStickyTopLayout() {
    return window.matchMedia('(max-width: ' + STICKY_TOP_LAYOUT_MAX_WIDTH + 'px)').matches;
  }

  function getProductInfo(sectionId) {
    return document.querySelector('product-info[data-section="' + sectionId + '"]');
  }

  function getMainSubmit(sectionId) {
    return document.getElementById('ProductSubmitButton-' + sectionId);
  }

  function getMainQuantityInput(sectionId) {
    return document.getElementById('Quantity-' + sectionId);
  }

  function getVariantSelects(productInfo) {
    return productInfo.querySelector('variant-selects');
  }

  function getCheckedInputForPosition(variantSelects, position) {
    return (
      variantSelects.querySelector('input[type="radio"][name$="-' + position + '"]:checked') ||
      variantSelects.querySelector('input.swatch-input__input[name$="-' + position + '"]:checked')
    );
  }

  function findMainInputByOptionValueId(variantSelects, optionValueId) {
    if (!optionValueId) return null;
    return variantSelects.querySelector('[data-option-value-id="' + optionValueId + '"]');
  }

  function syncStickySelects(productInfo, root) {
    var variantSelects = getVariantSelects(productInfo);
    if (!variantSelects) return;

    root.querySelectorAll('[data-sticky-option-position]').forEach(function (select) {
      var position = select.dataset.stickyOptionPosition;
      var checked = getCheckedInputForPosition(variantSelects, position);

      if (checked && checked.dataset.optionValueId) {
        var matchedOption = select.querySelector(
          'option[data-option-value-id="' + checked.dataset.optionValueId + '"]'
        );
        if (matchedOption && !matchedOption.disabled) {
          select.value = matchedOption.value;
          return;
        }
      }

      if (checked && checked.value) {
        select.value = checked.value;
        return;
      }

      var mainSelect = variantSelects.querySelector(
        'select[name="options[' + select.dataset.stickyOptionName + ']"]'
      );
      if (!mainSelect) {
        var index = parseInt(position, 10) - 1;
        mainSelect = variantSelects.querySelector('#Option-' + root.dataset.sectionId + '-' + index);
      }
      if (mainSelect) {
        select.value = mainSelect.value;
      }
    });
  }

  function syncStickyPrice(productInfo, root, variant) {
    var stickyPrice = root.querySelector('[data-sticky-atc-price]');
    if (!stickyPrice) return;

    var mainPrice = productInfo.querySelector('.pdp-atc__price');
    if (mainPrice && mainPrice.textContent.trim()) {
      stickyPrice.textContent = mainPrice.textContent.trim();
      return;
    }

    if (variant && typeof variant.price === 'number') {
      stickyPrice.textContent = formatMoney(variant.price, root.dataset.moneyFormat);
    }
  }

  function syncStickyImage(root, variant, productInfo) {
    var stickyImage = root.querySelector('[data-sticky-atc-image]');
    if (!stickyImage || stickyImage.tagName !== 'IMG') return;

    if (variant && variant.featured_image && variant.featured_image.src) {
      var src = variant.featured_image.src;
      stickyImage.src = src.indexOf('?') === -1 ? src + '?width=108' : src + '&width=108';
      return;
    }

    var mainImage = productInfo.querySelector('.product__media img, media-gallery img');
    if (mainImage && mainImage.src) {
      stickyImage.src = mainImage.src;
    }
  }

  function syncStickySubmitState(root, sectionId) {
    var mainSubmit = getMainSubmit(sectionId);
    var stickySubmit = root.querySelector('[data-sticky-atc-submit]');
    if (!mainSubmit || !stickySubmit) return;
    stickySubmit.disabled = mainSubmit.disabled;
  }

  function syncStickyQuantity(root, sectionId) {
    if (root.dataset.sleepysQtySyncing === '1') return;

    var mainQty = getMainQuantityInput(sectionId);
    var stickyQty = root.querySelector('[data-sticky-quantity-input]');
    if (!mainQty || !stickyQty) return;

    stickyQty.min = mainQty.min;
    stickyQty.max = mainQty.max || '';
    stickyQty.step = mainQty.step;
    if (stickyQty.value !== mainQty.value) {
      stickyQty.value = mainQty.value;
    }
  }

  function applyMainQuantityFromSticky(root, sectionId) {
    var mainQty = getMainQuantityInput(sectionId);
    var stickyQty = root.querySelector('[data-sticky-quantity-input]');
    if (!mainQty || !stickyQty) return;
    if (mainQty.value === stickyQty.value) return;

    root.dataset.sleepysQtySyncing = '1';
    mainQty.value = stickyQty.value;
    mainQty.dispatchEvent(new Event('change', { bubbles: true }));
    window.setTimeout(function () {
      delete root.dataset.sleepysQtySyncing;
    }, 0);
  }

  function updateStickyQtyButtons(root) {
    var stickyQtyWrap = root.querySelector('[data-sticky-quantity]');
    if (!stickyQtyWrap) return;

    var input = stickyQtyWrap.querySelector('[data-sticky-quantity-input]');
    if (!input) return;

    var value = parseInt(input.value, 10);
    var buttonMinus = stickyQtyWrap.querySelector(".quantity__button[name='minus']");
    var buttonPlus = stickyQtyWrap.querySelector(".quantity__button[name='plus']");

    if (buttonMinus && input.min) {
      buttonMinus.classList.toggle('disabled', value <= parseInt(input.min, 10));
    }
    if (buttonPlus && input.max) {
      buttonPlus.classList.toggle('disabled', value >= parseInt(input.max, 10));
    }
  }

  function initStickyQuantity(root, sectionId) {
    var stickyQtyWrap = root.querySelector('[data-sticky-quantity]');
    if (!stickyQtyWrap || stickyQtyWrap.dataset.sleepysQtyBound === '1') return;
    stickyQtyWrap.dataset.sleepysQtyBound = '1';

    var input = stickyQtyWrap.querySelector('[data-sticky-quantity-input]');
    if (!input) return;

    stickyQtyWrap.querySelectorAll('.quantity__button').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var previousValue = input.value;

        if (button.name === 'plus') {
          if (parseInt(input.min, 10) > parseInt(input.step, 10) && input.value === '0') {
            input.value = input.min;
          } else {
            input.stepUp();
          }
        } else if (button.name === 'minus') {
          input.stepDown();
        }

        if (input.min && previousValue === input.value && button.name === 'minus') {
          input.value = input.min;
        }

        if (previousValue !== input.value) {
          updateStickyQtyButtons(root);
          applyMainQuantityFromSticky(root, sectionId);
        }
      });
    });

    input.addEventListener('change', function () {
      updateStickyQtyButtons(root);
      if (root.dataset.sleepysQtySyncing === '1') return;
      applyMainQuantityFromSticky(root, sectionId);
    });

    updateStickyQtyButtons(root);
  }

  function openStickySelect(select) {
    if (!select || select.disabled) return;

    select.focus({ preventScroll: true });

    if (typeof select.showPicker === 'function') {
      try {
        select.showPicker();
        return;
      } catch (error) {
        // Fall back below when showPicker is blocked.
      }
    }

    select.click();
  }

  function initStickySelectWraps(root) {
    root.querySelectorAll('.pdp-sticky-atc__select-wrap').forEach(function (wrap) {
      if (wrap.dataset.sleepysSelectWrapBound === '1') return;
      wrap.dataset.sleepysSelectWrapBound = '1';

      var select = wrap.querySelector('select');
      if (!select) return;

      wrap.addEventListener('click', function (event) {
        if (select.contains(event.target)) return;
        event.preventDefault();
        openStickySelect(select);
      });

      wrap.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (event.target !== wrap && !wrap.contains(event.target)) return;
        if (select.contains(event.target)) return;
        event.preventDefault();
        openStickySelect(select);
      });
    });
  }

  function triggerMainOptionInput(input) {
    if (!input || input.disabled) return false;

    if (input.tagName === 'INPUT' && input.type === 'radio') {
      if (!input.checked) {
        input.checked = true;
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    if (input.tagName === 'OPTION') {
      var parentSelect = input.closest('select');
      if (parentSelect && parentSelect.value !== input.value) {
        parentSelect.value = input.value;
        parentSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    return false;
  }

  function restoreStickyScroll(root, clearPreserve) {
    if (!root.dataset.sleepysPreserveScroll) return;

    var scrollY = parseInt(root.dataset.sleepysPreserveScroll, 10);
    if (Number.isNaN(scrollY)) return;

    window.requestAnimationFrame(function () {
      window.scrollTo(0, scrollY);
    });

    if (clearPreserve) {
      delete root.dataset.sleepysPreserveScroll;
    }
  }

  function setMainVariantFromSticky(productInfo, root, select) {
    var selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    var variantSelects = getVariantSelects(productInfo);
    if (!variantSelects) return;

    root.dataset.sleepysStickySyncing = '1';
    root.dataset.sleepysPreserveScroll = String(window.scrollY);

    var optionValueId = selectedOption.dataset.optionValueId;
    var mainInput = findMainInputByOptionValueId(variantSelects, optionValueId);

    if (!mainInput) {
      var position = select.dataset.stickyOptionPosition;
      var value = select.value;
      var candidates = variantSelects.querySelectorAll(
        'input[type="radio"][name$="-' + position + '"], input.swatch-input__input[name$="-' + position + '"]'
      );
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].value === value) {
          mainInput = candidates[i];
          break;
        }
      }
    }

    triggerMainOptionInput(mainInput);

    window.setTimeout(function () {
      delete root.dataset.sleepysStickySyncing;
      syncStickySelects(productInfo, root);
    }, 120);
  }

  function getStickyAnchorTop() {
    if (!isStickyTopLayout()) return 0;

    var stickyTop = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--pdp-sticky-atc-top'),
      10
    );
    if (stickyTop > 0) return stickyTop;

    var stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) return stickyHeader.offsetHeight;

    var headerSection = document.querySelector('.section-header');
    return headerSection ? headerSection.offsetHeight : 0;
  }

  function shouldShowSticky(mainSubmit) {
    if (!mainSubmit) return false;
    var rect = mainSubmit.getBoundingClientRect();
    return rect.bottom <= getStickyAnchorTop();
  }

  function setStickyVisible(root, showSticky) {
    root.classList.toggle('is-visible', showSticky);
    root.setAttribute('aria-hidden', showSticky ? 'false' : 'true');
    document.body.classList.toggle('pdp-sticky-atc-is-visible', showSticky);
  }

  function updateStickyVisibility(root, mainSubmit) {
    setStickyVisible(root, shouldShowSticky(mainSubmit));
  }

  function mountStickyAtc(root) {
    if (root.parentNode !== document.body) {
      document.body.appendChild(root);
    }
  }

  function initPdpStickyAtc(root) {
    if (!root || root.dataset.sleepysStickyBound === '1') return;
    root.dataset.sleepysStickyBound = '1';

    var sectionId = root.dataset.sectionId;
    var productInfo = getProductInfo(sectionId);
    var mainSubmit = getMainSubmit(sectionId);
    if (!productInfo || !mainSubmit) {
      root.remove();
      return;
    }

    mountStickyAtc(root);
    root.removeAttribute('hidden');
    syncStickyTopOffset();
    syncStickySelects(productInfo, root);
    syncStickyQuantity(root, sectionId);
    syncStickyPrice(productInfo, root);
    syncStickySubmitState(root, sectionId);

    initStickyQuantity(root, sectionId);
    initStickySelectWraps(root);

    updateStickyVisibility(root, mainSubmit);

    var visibilityRaf = 0;
    function scheduleStickyVisibilityUpdate() {
      if (visibilityRaf) return;
      visibilityRaf = window.requestAnimationFrame(function () {
        visibilityRaf = 0;
        updateStickyVisibility(root, mainSubmit);
      });
    }

    window.addEventListener('scroll', scheduleStickyVisibilityUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyVisibilityUpdate);

    var stickySubmit = root.querySelector('[data-sticky-atc-submit]');
    if (stickySubmit) {
      stickySubmit.addEventListener('click', function () {
        applyMainQuantityFromSticky(root, sectionId);
        if (mainSubmit.disabled) return;
        mainSubmit.click();
      });
    }

    root.querySelectorAll('[data-sticky-option-position]').forEach(function (select) {
      select.addEventListener('change', function () {
        setMainVariantFromSticky(productInfo, root, select);
      });
    });

    var mainQty = getMainQuantityInput(sectionId);
    if (mainQty) {
      mainQty.addEventListener('change', function () {
        if (root.dataset.sleepysQtySyncing === '1') return;
        syncStickyQuantity(root, sectionId);
        updateStickyQtyButtons(root);
      });
    }

    productInfo.addEventListener('change', function (event) {
      if (root.dataset.sleepysStickySyncing === '1') return;
      if (!event.target || !event.target.closest('variant-selects')) return;
      if (!event.target.matches('input, select')) return;
      syncStickySelects(productInfo, root);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
        if (!event.data || !event.data.event || !event.data.event.target) return;
        if (!productInfo.contains(event.data.event.target)) return;
        if (root.dataset.sleepysStickySyncing === '1') return;
        syncStickySelects(productInfo, root);
      });

      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event.data || String(event.data.sectionId) !== String(sectionId)) return;
        syncStickySelects(productInfo, root);
        syncStickyPrice(productInfo, root, event.data.variant);
        syncStickyImage(root, event.data.variant, productInfo);
        syncStickyQuantity(root, sectionId);
        syncStickySubmitState(root, sectionId);
        updateStickyQtyButtons(root);
        restoreStickyScroll(root, false);
        window.setTimeout(function () {
          syncStickySubmitState(root, sectionId);
          syncStickyPrice(productInfo, root, event.data.variant);
          restoreStickyScroll(root, false);
        }, 50);
        window.setTimeout(function () {
          restoreStickyScroll(root, true);
        }, 300);
      });

      subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
        if (root.dataset.sleepysQtySyncing === '1') return;
        syncStickyQuantity(root, sectionId);
        updateStickyQtyButtons(root);
      });
    }

    var submitObserver = new MutationObserver(function () {
      syncStickySubmitState(root, sectionId);
      syncStickyPrice(productInfo, root);
    });
    submitObserver.observe(mainSubmit, { attributes: true, childList: true, subtree: true });
  }

  var resizeRaf = 0;
  function scheduleStickyTopSync() {
    if (resizeRaf) return;
    resizeRaf = window.requestAnimationFrame(function () {
      resizeRaf = 0;
      syncStickyTopOffset();
      document.querySelectorAll('[data-pdp-sticky-atc].is-visible, [data-pdp-sticky-atc]').forEach(function (root) {
        var mainSubmit = getMainSubmit(root.dataset.sectionId);
        if (mainSubmit) updateStickyVisibility(root, mainSubmit);
      });
    });
  }

  window.addEventListener('resize', scheduleStickyTopSync);

  document.addEventListener('DOMContentLoaded', function () {
    syncStickyTopOffset();
    document.querySelectorAll('[data-pdp-sticky-atc]').forEach(initPdpStickyAtc);
  });

  document.addEventListener('shopify:section:load', function (event) {
    syncStickyTopOffset();
    var root = event.target && event.target.querySelector('[data-pdp-sticky-atc]');
    if (root) initPdpStickyAtc(root);
  });
})();
